<template>
  <div class="contact-panel__wrapper">
    <div
      class="contact-panel"
      :class="[
        state.isMinimized ? 'contact-panel--minimized' : '',
        state.isMinimized && inboundQueuedConferences.length > 0 && socketStore.agentStatus !== 'offline'
          ? 'contact-panel--pulsing'
          : ''
      ]"
    >
      <div
        v-if="!state.isMinimized"
        class="contact-panel__inner-wrapper"
      >
        <div class="contact-panel__buttons">
          <div
            class="contact-panel__buttons__button"
            @click="state.isMinimized = !state.isMinimized"
          >
            <Icon :type="state.isMinimized ? 'up-right-and-down-left-from-center' : 'minus'" />
          </div>
        </div>

        <!-- Call List -->
        <div
          v-if="
            !state.isMinimized && (currentAgentStatus.value == 'on-call' || currentAgentStatus.value == 'available')
          "
          class="contact-panel__section border-r border-border-tertiary"
        >
          <div
            v-if="!state.isDialpadOpen"
            class="contact-panel__section-content scrollable"
          >
            <div>
              <!-- <div class="ml-2 text-sm text-secondary">Active</div> -->
              <ContactPanelItem
                v-for="conference in userConferences"
                :key="conference"
                :item="conference"
                :is-selected="conference.name == state.selectedContact?.name"
                :active-conference-name="state.activeConferenceName"
                :disabled="state.activeCallSid"
                :is-muted="state.device.isMuted"
                :show-audio-wave="true"
                @mute-click="toggleMute"
                @click="selectContact(conference)"
                @end-call="hangUp()"
              />
            </div>

            <div>
              <div class="ml-2 text-sm text-secondary mt-2">Queue</div>
              <ContactPanelItem
                v-for="conference in queuedConferences"
                :key="conference.id"
                :item="conference"
                :disabled="state.activeCallSid || state.isConnecting"
                :is-selected="conference.name == state.selectedContact?.name"
                @click="selectContact(conference)"
                @accept-call="answerConference(conference)"
              />
            </div>
          </div>

          <div
            v-if="state.isDialpadOpen"
            class="contact-panel__section-content"
          >
            <div class="flex flex-col items-center mb-4 mt-2">
              <!-- <Button :is-dropdown="false" label="+44 1628624700" size="xs" plain severity="secondary" /> -->
              <!-- <div v-tippy="{ content: `Calling From` }" class="text-sm text-tertiary mb-1">
              {{ state.dialpad.fromName || 'no from number' }}
            </div> -->
              <Chip
                :label="state.dialpad.fromName || 'select a number'"
                size="sm"
                icon="map-marker"
                class="mb-2"
              />
              <input
                v-model="state.dialpad.to"
                type="text"
                class="text-center bg-transparent"
                placeholder="Enter number"
              />
            </div>
            <div>
              <div class="contact-panel__keypad select-none">
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('1')"
                >
                  1
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('2')"
                >
                  2
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('3')"
                >
                  3
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('4')"
                >
                  4
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('5')"
                >
                  5
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('6')"
                >
                  6
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('7')"
                >
                  7
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('8')"
                >
                  8
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('9')"
                >
                  9
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('*')"
                >
                  *
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('0')"
                >
                  0
                </div>
                <div
                  class="contact-panel__keypad_button"
                  @click="keypadPress('#')"
                >
                  #
                </div>
              </div>
            </div>
            <div class="flex justify-center mt-4">
              <Button
                v-if="state.activeCallSid"
                icon="phone-hangup"
                rounded
                severity="danger"
                size="md"
                @click="hangUp"
              />
              <Button
                v-else
                icon="phone"
                rounded
                severity="success"
                size="md"
                :is-loading="state.isConnecting"
                :disabled="
                  !fromValidator.validatedData.value.valid ||
                  !toValidator.validatedData.value.valid ||
                  state.isConnecting ||
                  state.activeCallSid
                "
                @click="initiateOutboundCall"
              />
            </div>
          </div>

          <div class="contact-panel__section-footer ml-2">
            <Dropdown v-if="socketStore.socketIsConnected">
              <template #triggerContent>
                <div class="cursor-pointer py-1 flex items-center justify-center">
                  <Icon
                    :type="currentAgentStatus.icon"
                    fa-style="fa-duotone fa-solid"
                    :class="[`fg-${currentAgentStatus?.color}`]"
                    class="text-sm"
                  />
                  <div class="w-full ml-1">{{ capitalize(socketStore.agentStatus) }}</div>
                  <Icon
                    type="chevron-down"
                    class="ml-1"
                  />
                </div>
              </template>
              <div
                v-for="status in callAgentStatusOptions"
                :key="status.value"
              >
                <DropdownItem
                  v-if="status?.value !== currentAgentStatus?.value && status.isSelectable"
                  @click="updateAgentStatus(status.value)"
                >
                  <div class="flex items-center text-sm">
                    <Icon
                      :type="status.icon"
                      fa-style="fa-duotone fa-solid"
                      :class="[`fg-${status.color}`]"
                      class="mr-2"
                    />
                    {{ status.label }}
                  </div>
                </DropdownItem>
              </div>
            </Dropdown>
            <div
              v-else
              v-tippy="{ content: 'You aren\'t connected to the server' }"
            >
              No connection
            </div>

            <div>
              <!-- <Button icon="material-mic_off" plain severity="secondary" size="sm" /> -->
              <Button
                v-if="state.isDialpadOpen"
                icon="material-call_log"
                plain
                severity="secondary"
                size="sm"
                @click="state.isDialpadOpen = false"
              />
              <Button
                v-else
                icon="dialpad"
                plain
                severity="secondary"
                size="sm"
                @click="state.isDialpadOpen = true"
              />
            </div>
          </div>
        </div>

        <!-- Details Panel -->
        <div
          v-if="
            !state.isMinimized &&
            state.selectedContact &&
            (currentAgentStatus.value == 'on-call' || currentAgentStatus.value == 'available')
          "
          class="contact-panel__section w-[300px]"
        >
          <div class="contact-panel__section-content">
            <!-- <Dropdown class="w-full" :close-on-click-within="false" :padding="false">
          <template #triggerContent>
            <div class="contact-panel__customer-selector">
              <div>
                <div v-if="state.selectedContact?.customerData">
                  <div class="font-semibold">{{ state.selectedContact?.customerData?.name }}</div>
                  <div class="text-xs -mt-1 text-tertiary">{{ state.selectedContact?.customerData?.vrm }}</div>
                </div>
                <div v-else>
                  <div>Select customer</div>
                </div>
              </div>
              <Icon type="chevron-down" class="text-secondary" />
            </div>
          </template>
          <div class="px-3 py-3">
            <Select v-model="state.selectedContact" :options="state.selectedContact?.possibleCustomerMatches" @select="selectCustomer" />
            <div class="mt-4 px-2">
              <div class="text-sm text-tertiary">Possible Matches</div>
              <div>
                <DropdownItem :close-on-click="false" compact>John Doe</DropdownItem>
                <DropdownItem :close-on-click="false" compact>Jane Doe</DropdownItem>
                <DropdownItem :close-on-click="false" compact>John Anderson</DropdownItem>
              </div>
            </div>
          </div>
        </Dropdown> -->

            <div v-if="contactPanelContentView == 'customer'">
              <div class="px-2 py-1">
                <AvatarLabelGroup
                  :label="state.selectedContact?.phoneNumberDetails?.name"
                  :description="state.selectedContact?.phoneNumberDetails?.isoNumber"
                  avatar-icon="location-dot"
                  size="sm"
                />
              </div>

              <FormGroup class="mt-2 px-2 flex gap-2">
                <Select
                  v-model="state.wrapUpData.agreementId"
                  v-model:search-term="searchTerm"
                  :options="agreementsList"
                  value-key="agreementId"
                  label-key="name"
                  searchable
                  placeholder="Select Customer"
                  :handle-search="false"
                  @change="linkAgreementToContact"
                >
                  <template #option="{ option }">{{ option.name }} [{{ option.vrm }}]</template>
                </Select>

                <div
                  v-tippy="{
                    content: !state.wrapUpData?.agreementId ? 'No customer selected' : 'View agreement'
                  }"
                >
                  <Button
                    :disabled="!state.wrapUpData?.agreementId"
                    icon="eye"
                    severity="primary"
                    size="sm"
                    outlined
                    :router-link="'/agreement/' + state.wrapUpData?.agreementId"
                  />
                </div>
              </FormGroup>

              <div
                v-if="false && state.selectedContact?.customerData"
                class="hidden"
              >
                <div class="mx-2">
                  <AgreementPreview
                    :preview-pane-data="state.selectedContact?.customerData"
                    used-for="contact-panel"
                  />
                </div>
              </div>
            </div>

            <div
              v-else-if="contactPanelContentView == 'outcome'"
              class="mx-2"
            >
              <FormGroup
                label="Answered by"
                :is-required="v$.answeredBy.required"
              >
                <RadioTabbed
                  v-model="state.wrapUpData.answeredBy"
                  :options="[
                    {
                      label: 'Customer',
                      value: 'human_manual'
                    },
                    {
                      label: 'Voicemail',
                      value: 'machine_start_manual'
                    },
                    {
                      label: 'N/A',
                      value: 'N/A'
                    }
                  ]"
                  full-width
                  :has-error="v$.answeredBy.$error"
                />
                <InputError :has-error="v$.answeredBy.$error">{{ v$.answeredBy.$errors[0]?.$message }}</InputError>
              </FormGroup>

              <FormGroup v-if="state.wrapUpData.answeredBy != 'N/A'">
                <Checkbox
                  v-model="state.wrapUpData.agentConsidersCompliant"
                  label="Compliant"
                />
              </FormGroup>

              <FormGroup :is-required="v$.reasonForCall.required">
                <Select
                  v-model="state.wrapUpData.reasonForCall"
                  :options="['Finance Review', 'Lead', 'Appointment - Existing', 'Appointment - Follow-up', 'Other']"
                  placeholder="Reason for Call"
                  :has-error="v$.reasonForCall.$error"
                />
                <InputError :has-error="v$.reasonForCall.$error">
                  {{ v$.reasonForCall.$errors[0]?.$message }}
                </InputError>
              </FormGroup>

              <FormGroup :is-required="v$.tags.required">
                <Select
                  v-model="state.wrapUpData.tags"
                  mode="multiple"
                  chips
                  searchable
                  handle-search
                  :options="[
                    'Left Message',
                    'Decided',
                    'Unaware of Options',
                    'Undecided',
                    'Confused',
                    'Dubious',
                    'Going Elsewhere',
                    'Disappointed',
                    'Complaint',
                    'Refused Data Protection',
                    'Booked Appointment',
                    'Appointment Query',
                    'Appointment Complaint',
                    'Inconvenient Time',
                    'Connection Issues',
                    'Incorrect Number',
                    'Call Failed',
                    'Phone System Error',
                    'Unable to Complete DPQ',
                    'Answered by Other Party',
                    'Answered by Relative'
                  ]"
                  placeholder="Tags"
                  :has-error="v$.tags.$error"
                >
                  <template #tag="{ option, handleTagRemove, disabled }">
                    <div
                      class="multiselect-tag"
                      :class="{
                        'is-disabled': disabled
                      }"
                    >
                      {{ option.value }}
                      <span
                        v-if="!disabled"
                        class="multiselect-tag-remove"
                        @click="handleTagRemove(option, $event)"
                      >
                        <!-- <span class="multiselect-tag-remove-icon"></span> -->
                        <Icon type="xmark" />
                      </span>
                    </div>
                  </template>
                </Select>
                <InputError :has-error="v$.tags.$error">{{ v$.tags.$errors[0]?.$message }}</InputError>
              </FormGroup>

              <FormGroup :is-required="v$.notes.required">
                <TextArea
                  v-model="state.wrapUpData.notes"
                  has-border
                  placeholder="Type a note..."
                  rows="2"
                  :has-error="v$.notes.$error"
                />
                <InputError :has-error="v$.notes.$error">{{ v$.notes.$errors[0]?.$message }}</InputError>
              </FormGroup>

              <div>
                <Button
                  icon="circle-check"
                  label="Submit"
                  severity="primary"
                  size="sm"
                  @click="completeWrapUp"
                />
              </div>
            </div>
          </div>
          <!-- Footer -->
          <div class="contact-panel__section-footer">
            <RadioTabbed
              v-model="contactPanelContentView"
              :options="[
                { value: 'customer', label: 'Customer' },
                { value: 'outcome', label: 'Outcome' }
              ]"
              full-width
            />
          </div>
        </div>

        <!-- Temp debug section -->
        <div class="contact-panel__section !hidden">
          <div class="contact-panel__section-content">
            <div class="text-sm text-secondary">Debug</div>
            <div class="text-xs text-tertiary">Active Call SID: {{ state.activeCallSid }}</div>
            <div class="text-xs text-tertiary">Active Conference Name: {{ state.activeConferenceName }}</div>
            <div class="text-xs text-tertiary">Selected Contact: {{ state.selectedContact }}</div>
            <div class="text-xs text-tertiary">Device Registered: {{ state.device.isRegistered }}</div>
            <div class="text-xs text-tertiary">Device Muted: {{ state.device.isMuted }}</div>
            <div class="text-xs text-tertiary">Dialpad Open: {{ state.isDialpadOpen }}</div>
            <!-- <div class="text-xs text-tertiary">Agreement: {{ state.selectedContact?.customerData }}</div> -->
            <div class="text-xs text-tertiary">
              WrapUp:
              <pre>{{ state.wrapUpData }}</pre>
            </div>
          </div>
        </div>

        <!-- If not available or on-call -->
        <div
          v-if="
            !state.isMinimized && currentAgentStatus.value !== 'on-call' && currentAgentStatus.value !== 'available'
          "
          class="contact-panel__section"
        >
          <div
            v-if="socketStore.socketIsConnected"
            class="flex flex-col justify-center items-center p-10 h-full"
          >
            <!-- Call Center Selector -->
            <div class="mb-4">
              <Dropdown>
                <template #triggerContent>
                  <div
                    class="cursor-pointer py-1 px-2 flex gap-2 items-center justify-center text-sm border border-border-secondary rounded"
                  >
                    <Icon type="headset" />
                    <div
                      v-if="selectedCallCenter"
                      class="text-sm"
                    >
                      {{ selectedCallCenterName }}
                    </div>
                    <div
                      v-else
                      class="text-sm text-quaternary"
                    >
                      Select Call Center
                    </div>
                    <Icon type="chevron-down" />
                  </div>
                </template>
                <DropdownItem
                  v-for="center in callCenters"
                  :key="center.id"
                  @item-clicked="changeCallCenter(center.id)"
                >
                  {{ center.name }}
                </DropdownItem>
                <DropdownItem @item-clicked="changeCallCenter(null)">None</DropdownItem>
              </Dropdown>
            </div>

            <Icon
              :type="socketStore.agentStatus == 'break' ? 'mug-hot' : 'circle-xmark'"
              class="text-[3rem] text-fg-senary"
            />
            <div>
              <Dropdown class="text-sm">
                <template #triggerContent>
                  <div class="cursor-pointer py-1 px-2 flex items-center justify-center">
                    <Icon
                      type="circle"
                      fa-style="fa-duotone fa-solid"
                      :class="[`fg-${currentAgentStatus?.color}`]"
                      class="text-xs"
                    />
                    <div class="w-full ml-1">{{ capitalize(socketStore.agentStatus) }}</div>
                    <Icon
                      type="chevron-down"
                      class="ml-1"
                    />
                  </div>
                </template>
                <div
                  v-for="status in callAgentStatusOptions"
                  :key="status.value"
                >
                  <DropdownItem
                    v-if="status?.value !== currentAgentStatus?.value && status.isSelectable"
                    @click="updateAgentStatus(status.value)"
                  >
                    <div class="flex items-center text-sm">
                      <Icon
                        :type="status.icon"
                        fa-style="fa-duotone fa-solid"
                        :class="[`fg-${status.color}`]"
                        class="mr-2"
                      />
                      {{ status.label }}
                    </div>
                  </DropdownItem>
                </div>
              </Dropdown>
            </div>
          </div>
          <div
            v-else
            class="flex flex-col justify-center items-center p-10 h-full"
          >
            <Icon
              type="wifi-slash"
              class="text-[3rem] text-fg-senary"
            />

            <div>No connection</div>
            <div class="text-sm text-quaternary">You aren't connected to the server</div>
          </div>
        </div>
      </div>

      <!-- Minimized version -->
      <div
        v-if="state.isMinimized"
        class="flex gap-2 items-end"
        @click="state.isMinimized = false"
      >
        <div class="mx-2 flex gap-2 justify-center items-center h-full">
          <!-- Call Center Selector -->
          <Dropdown @click.stop>
            <template #triggerContent>
              <div
                class="cursor-pointer py-1 px-2 flex gap-2 items-center justify-center text-sm border border-border-secondary rounded"
              >
                <Icon type="headset" />
                <div
                  v-if="selectedCallCenter"
                  class="text-sm whitespace-nowrap"
                >
                  {{ selectedCallCenterName }}
                </div>
                <div
                  v-else
                  class="text-sm text-quaternary whitespace-nowrap"
                >
                  Select Call Center
                </div>
                <Icon type="chevron-down" />
              </div>
            </template>
            <DropdownItem
              v-for="center in callCenters"
              :key="center.id"
              @item-clicked="changeCallCenter(center.id)"
            >
              {{ center.name }}
            </DropdownItem>
            <DropdownItem @item-clicked="changeCallCenter(null)">None</DropdownItem>
          </Dropdown>

          <!-- Status Display -->
          <div
            v-if="socketStore.socketIsConnected"
            class="cursor-pointer py-1 px-2 flex items-center justify-center"
          >
            <Icon
              :type="currentAgentStatus.icon"
              fa-style="fa-duotone fa-solid"
              :class="[`fg-${currentAgentStatus?.color}`]"
              class="text-sm"
            />
            <div class="w-full ml-1">{{ capitalize(socketStore.agentStatus) }}</div>
            <!-- <Icon type="chevron-down" class="ml-1" /> -->
          </div>
          <div
            v-else
            class="cursor-pointer py-1 px-2 flex items-center justify-center gap-2"
          >
            <Icon
              type="wifi-slash"
              fa-style="fas"
              class="text-sm text-secondary"
            />
            <div>No connection</div>
          </div>
          <Button
            icon="phone"
            plain
            severity="secondary"
            size="sm"
          />
        </div>
        <div v-if="socketStore.agentStatus === 'available' || socketStore.agentStatus == 'on-call'">
          <div class="flex gap-2">
            <ContactPanelItem
              v-for="conference in userConferences"
              :key="conference"
              :item="conference"
              :is-selected="conference.name == state.selectedContact?.name"
              :active-conference-name="state.activeConferenceName"
              :disabled="state.activeCallSid"
              :is-muted="state.device.isMuted"
              :inline-buttons="true"
              :show-audio-wave="true"
              :show-icon="false"
              @mute-click="toggleMute"
              @click="selectContact(conference)"
              @end-call="hangUp()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal
    :is-open="unlinkedCustomerModalIsOpen"
    min-width="350"
    icon="user"
    title="No customer linked"
    description="Provide a reason why a customer couldn't be linked"
    :buttons="['close', 'ok']"
    :button-colors="{ close: 'secondary', ok: 'primary' }"
    ok-text="Submit"
    close-text="Cancel"
    :show-loader-on-confirm="true"
    :is-confirming="wrapupIsLoading"
    :disable-close="wrapupIsLoading"
    @close-modal="unlinkedCustomerModalIsOpen = false"
    @ok-modal="submitWrapUp"
  >
    <FormGroup
      v-if="!state.wrapUpData.agreementId"
      :label="$t('ui.common.reason')"
    >
      <TextArea
        v-model="state.unlinkedData.unlinkedReason"
        :value="state.unlinkedData.unlinkedReason"
        spell-check
        :rows="3"
        :has-error="vUnlinked$.unlinkedReason.$error"
      />
      <InputError :has-error="vUnlinked$.unlinkedReason.$error">
        {{ vUnlinked$.unlinkedReason.$errors[0]?.$message }}
      </InputError>
    </FormGroup>
  </Modal>
</template>

<script setup>
import { ref, computed, onMounted, watchEffect, watch, inject, onUnmounted } from 'vue'
import axios from 'axios'
import { capitalize } from 'lodash'
import { Device } from '@twilio/voice-sdk'
import useVuelidate from '@vuelidate/core'
import { required, requiredIf, helpers } from '@vuelidate/validators'

import Button from '@/components/button/Button.vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import DropdownItem from '@/components/dropdown/DropdownItem.vue'
import Select from '@/components/forms/Select.vue'
import Icon from '@/components/icon/Icon.vue'
import FormGroup from '@/components/forms/FormGroup.vue'
import Checkbox from '@/components/forms/Checkbox.vue'
import Chip from '@/components/chip/Chip.vue'
import RadioTabbed from '../forms/RadioTabbed.vue'
import TextArea from '@/components/forms/TextArea.vue'
import InputError from '../forms/InputError.vue'
import AgreementPreview from '../unique/preview-panes/AgreementPreview.vue'
import AvatarLabelGroup from '@/components/avatar/AvatarLabelGroup.vue'
import Modal from '../modal/Modal.vue'

import ContactPanelItem from '@/components/contact-panel/ContactPanelItem.vue'

// stores
import { useAuthStore } from '@/stores/AuthStore.ts'
import { useCallCenterStore } from '@/stores/CallCenterStore.ts'
import { useSocketStore } from '@/stores/SocketStore.ts'
import usePhoneValidator from '@/composables/usePhoneValidator'
import { useInboundCallNotifications } from '@/composables/useInboundCallNotifications'
import { alertToast } from '@/utilities/notification'
import useMeilisearch from '@/composables/useMeilisearch'

const authStore = useAuthStore()
const callCenterStore = useCallCenterStore()
const socketStore = useSocketStore()

const state = ref({
  twilioToken: null,
  isMinimized: true,
  isDialpadOpen: false,
  activeCallSid: null,
  activeConferenceName: null,
  selectedContact: null,
  isConnecting: false,
  unlinkedData: {
    unlinkedReason: null
  },
  device: {
    isRegistered: false,
    isMuted: false
  },
  dialpad: {
    from: '',
    to: '',
    fromIsValid: false,
    toIsValid: false
  },
  wrapUpData: {
    agreementId: null,
    reasonForCall: null,
    answeredBy: null,
    tags: [],
    agentConsidersCompliant: false,
    notes: ''
  }
})

const agreementsList = ref([])
const searchTerm = ref('')
const meiliSearchResults = ref([])
const { createSearch, initClient, getClient } = useMeilisearch()
const contactPanelContentView = ref('customer')
const unlinkedCustomerModalIsOpen = ref(false)
const wrapupIsLoading = ref(false)
const preserveAgreementSelectionOnNextContactChange = ref(false)
const pendingPreselectedAgreementId = ref(null)

const viewAllowed = authStore.accessAllowed
const dealershipIds = viewAllowed.dealerships.map(dealership => dealership.id)
const dealershipIdsString = dealershipIds.join(',')

const inputRules = {
  agreementId: {},
  reasonForCall: { required },
  answeredBy: { required },
  tags: {},
  agentConsidersCompliant: {},
  notes: {}
}
const unlinkedReasonRules = {
  unlinkedReason: {
    requiredIf: helpers.withMessage(
      'Required',
      requiredIf(() => !state.value.wrapUpData.agreementId)
    )
  }
}
const wrapUpDataVuelidateCopy = computed(() => {
  return state.value.wrapUpData
})
const unlinkedDataVuelidateCopy = computed(() => {
  return state.value.unlinkedData
})
const v$ = useVuelidate(inputRules, wrapUpDataVuelidateCopy)
const vUnlinked$ = useVuelidate(unlinkedReasonRules, unlinkedDataVuelidateCopy)

const { scheduleSearch, dispose: disposeSearch } = createSearch(
  async ({ client, signal, query }) => {
    return client.index('agreements').search(
      query,
      {
        filter: 'dealershipId IN [' + dealershipIdsString + ']'
        // attributesToHighlight: ['*'],
        // highlightPreTag: '<span class="search-results-highlight">',
        // highlightPostTag: '</span>'
      },
      { signal }
    )
  },
  {
    debounceMs: 350,
    onClear: () => {
      meiliSearchResults.value = []
      agreementsList.value = []
    },
    onResult: results => {
      meiliSearchResults.value = results
      agreementsList.value = meiliSearchResults.value.hits || []
    }
  }
)

watch(searchTerm, newSearchTerm => {
  scheduleSearch(newSearchTerm)
})

function linkAgreementToContact() {
  if (!state.value.selectedContact) {
    return
  }

  // Find the value from the meilisearch results
  const selectedAgreement = agreementsList.value.find(
    agreement => agreement.agreementId === state.value.wrapUpData.agreementId
  )
  if (selectedAgreement) {
    state.value.selectedContact.customerData = selectedAgreement
  }
}

/**
 * Searches for an agreement by ID and preselects it for wrap-up linking.
 * @param {string|number|null|undefined} agreementId - Agreement ID passed into the dialpad flow.
 * @returns {Promise<void>}
 */
async function preselectAgreementById(agreementId) {
  const parsedAgreementId = Number(agreementId)
  if (!Number.isInteger(parsedAgreementId) || parsedAgreementId <= 0) {
    return
  }

  try {
    initClient()
    const client = getClient()
    if (!client) {
      return
    }

    const searchResponse = await client.index('agreements').search(String(parsedAgreementId), {
      filter: 'dealershipId IN [' + dealershipIdsString + ']',
      limit: 20
    })

    const matchedAgreement = searchResponse?.hits?.find(
      agreement => Number(agreement?.agreementId) === parsedAgreementId
    )
    if (!matchedAgreement) {
      return
    }

    agreementsList.value = [matchedAgreement]
    state.value.wrapUpData.agreementId = matchedAgreement.agreementId
    preserveAgreementSelectionOnNextContactChange.value = true
    pendingPreselectedAgreementId.value = null

    if (state.value.selectedContact) {
      linkAgreementToContact()
    }
  } catch (error) {
    console.error('Failed to preselect agreement by ID:', error)
  }
}

let device
let tokenRefreshTimer = null

const callAgentStatusOptions = [
  {
    value: 'available',
    label: 'Available',
    color: 'success',
    icon: 'circle-check',
    isSelectable: true
  },
  {
    value: 'on-call',
    label: 'On Call',
    color: 'success',
    icon: 'circle-phone',
    isSelectable: false
  },
  { value: 'break', label: 'Break', color: 'warning', icon: 'circle-pause', isSelectable: true },
  { value: 'offline', label: 'Offline', color: 'secondary', icon: 'circle-x', isSelectable: true }
]

const currentAgentStatus = computed(() =>
  callAgentStatusOptions.find(option => option.value === socketStore.agentStatus)
)

function updateAgentStatus(status) {
  socketStore.updateAgentStatus(status)
}

// Call Center
const callCenters = computed(() => callCenterStore.callCenters ?? [])
const selectedCallCenter = computed(() => callCenterStore.selectedCallCenter)

const selectedCallCenterName = computed(() => {
  const callCenter = callCenters.value?.find(callCenter => callCenter.id == selectedCallCenter.value)
  return callCenter?.name
})

function changeCallCenter(id) {
  callCenterStore.selectCallCenter(id)
}

const userConferences = computed(() =>
  socketStore.callCenterConferences?.filter(conf => conf.agentId === authStore.details.id)
)
const queuedConferences = computed(() =>
  socketStore.callCenterConferences?.filter(conf => conf.agentId !== authStore.details.id && conf.agentId === null)
)

// Filter queued conferences to only inbound calls
const inboundQueuedConferences = computed(
  () => queuedConferences.value?.filter(conf => conf.direction === 'inbound') || []
)

// Initialize inbound call notifications composable
const { manageNotifications } = useInboundCallNotifications()

// Watch for changes in inbound queued calls and manage notifications
watch(
  () => inboundQueuedConferences.value.length,
  count => {
    // Only manage notifications if agent is available
    if (socketStore.agentStatus === 'available') {
      manageNotifications(count)
    } else {
      manageNotifications(0)
    }
  },
  { immediate: true }
)

// Also watch agent status to stop notifications when not available
watch(
  () => socketStore.agentStatus,
  status => {
    if (status !== 'available') {
      manageNotifications(0)
    } else {
      manageNotifications(inboundQueuedConferences.value.length)
    }
  }
)

function selectContact(contact) {
  // If in an active call, don't allow selecting a new contact, unless it is the active call
  if (state.value.activeCallSid) {
    return
  }
  state.value.selectedContact = contact
  contactPanelContentView.value = 'customer'
}

/**
 * Parses a JWT token and extracts the expiration timestamp
 * @param {string} token - The JWT token string
 * @returns {number|null} The expiration timestamp in milliseconds, or null if parsing fails
 */
function getTokenExpiration(token) {
  try {
    // JWT tokens have three parts separated by dots: header.payload.signature
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    // Decode the payload (second part)
    // Base64URL decoding: replace - with +, _ with /, and add padding if needed
    const payload = parts[1]
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const decoded = atob(padded)
    const parsed = JSON.parse(decoded)

    // Return expiration time in milliseconds (exp is in seconds)
    return parsed.exp ? parsed.exp * 1000 : null
  } catch (error) {
    console.error('Failed to parse token expiration:', error)
    return null
  }
}

/**
 * Sets up a timer to refresh the token before it expires
 * Refreshes 5 minutes before expiration, or at 50% of token lifetime, whichever is shorter
 * @param {string} token - The current token
 */
function scheduleTokenRefresh(token) {
  // Clear any existing timer
  if (tokenRefreshTimer) {
    clearTimeout(tokenRefreshTimer)
    tokenRefreshTimer = null
  }

  const expirationTime = getTokenExpiration(token)
  if (!expirationTime) {
    console.warn('Could not determine token expiration, will rely on tokenWillExpire event')
    return
  }

  const now = Date.now()
  const timeUntilExpiration = expirationTime - now

  if (timeUntilExpiration <= 0) {
    // Token already expired, refresh immediately
    refreshTokenAndUpdateDevice()
    return
  }

  // Refresh 5 minutes before expiration, or at 50% of token lifetime, whichever is shorter
  const refreshBuffer = 5 * 60 * 1000 // 5 minutes in milliseconds
  const halfLifetime = timeUntilExpiration / 2
  const refreshDelay = Math.min(refreshBuffer, halfLifetime)

  tokenRefreshTimer = setTimeout(() => {
    refreshTokenAndUpdateDevice()
  }, refreshDelay)

  // console.info(
  //   `Token refresh scheduled in ${Math.round(refreshDelay / 1000 / 60)} minutes (expires in ${Math.round(timeUntilExpiration / 1000 / 60)} minutes)`
  // )
}

/**
 * Fetches a token from the server
 * @returns {Promise<string>} The token string
 */
async function fetchToken() {
  const tokenUrl = import.meta.env.VITE_SOCKET_IO_SERVER_URL + '/cc/client-token?user_id=' + authStore.details.id
  const response = await axios.get(tokenUrl, { withCredentials: false })

  // Checking if there's a token in the response
  if (!response.data || !response.data.token || response.data.token.length === 0) {
    throw new Error('No valid token found in the response.')
  }

  return response.data.token
}

/**
 * Refreshes the token and updates the device with the new token
 */
async function refreshTokenAndUpdateDevice() {
  try {
    const newToken = await fetchToken()
    state.value.twilioToken = newToken

    // Update the device with the new token
    if (device) {
      device.updateToken(newToken)
      // console.info('Token refreshed and device updated successfully')
    }

    // Schedule the next refresh
    scheduleTokenRefresh(newToken)
  } catch (error) {
    console.error('Failed to refresh token:', error)
    alertToast('Token Refresh Failed', 'Failed to refresh phone system token. Please refresh the page.', 'error')
  }
}

// Device initialization function
async function initDevice() {
  const deviceOptions = {
    appName: 'App V3',
    appVersion: import.meta.env.VITE_VERSION,
    // closeProtection: true,
    loglevel: 1,
    enableImprovedSignalingErrorPrecision: true
    // sounds: {
    //   incoming: 'https://assets.mixkit.co/sfx/preview/mixkit-uplifting-flute-notification-2317.mp3',
    //   outgoing: 'https://assets.mixkit.co/sfx/preview/mixkit-software-interface-start-2574.mp3',
    //   disconnect: 'https://assets.mixkit.co/sfx/preview/mixkit-software-interface-back-2575.mp3'
    // }
  }

  device = new Device(state.value.twilioToken, deviceOptions)

  device.on('registered', function () {
    state.value.device.isRegistered = true
  })

  device.register()

  device.on('error', async twilioError => {
    if (twilioError.code === 20104 || twilioError.code === 20101) {
      // Error: Access Token has expired or expiration date is invalid
      // Refresh token and update device
      await refreshTokenAndUpdateDevice()
      return
    }

    // If any unhandled error, show notification to user
    alertToast('Twilio Error: ' + twilioError.code, twilioError.description, 'error')
  })

  device.on('tokenWillExpire', async () => {
    // Refresh token before it expires
    await refreshTokenAndUpdateDevice()
  })
}

onMounted(async () => {
  try {
    // Fetch the initial token
    state.value.twilioToken = await fetchToken()
    await initDevice()

    // Schedule proactive token refresh
    scheduleTokenRefresh(state.value.twilioToken)
  } catch (error) {
    console.error('Failed to initialize Twilio device:', error)
    alertToast('Phone System Error', 'Failed to initialize phone system. Please refresh the page.', 'error')
  }
})

let call

async function answerConference(conference) {
  // Prevent multiple simultaneous calls
  if (state.value.isConnecting || state.value.activeCallSid) {
    return
  }

  state.value.isConnecting = true

  try {
    call = await device.connect({
      params: {
        To: conference.name,
        isJoiningConference: true,
        callingEntityType: 'agent',
        callingEntityId: authStore.details.id
      }
    })

    // Call Error event
    call.on('error', error => {
      console.error('TWILIO CALL ERROR')
      console.error(error)
      state.value.isConnecting = false
    })

    // Call Warning event
    call.on('warning', (warningName, warningData) => {
      console.warn('TWILIO CALL WARNING')
      console.warn(warningName, warningData)
    })

    call.on('warning-cleared', function () {
      console.warn('TWILIO CALL WARNING - CLEARED')
    })

    // For outgoing calls, the "accept" event is emitted when the Call's media session has finished setting up.
    call.on('accept', () => {
      state.value.activeConferenceName = conference.name
      state.value.activeCallSid = call.parameters.CallSid
      state.value.isConnecting = false

      socketStore.updateAgentStatus('on-call')
    })

    call.on('disconnect', () => {
      state.value.activeCallSid = null
      state.value.isConnecting = false

      socketStore.updateAgentStatus('available')
    })
  } catch (error) {
    console.error('Failed to initiate call:', error)
    state.value.isConnecting = false
  }
}

async function initiateOutboundCall() {
  // Prevent multiple simultaneous calls
  if (state.value.isConnecting || state.value.activeCallSid) {
    return
  }

  state.value.isConnecting = true

  try {
    call = await device.connect({
      params: {
        To: state.value.dialpad.to,
        From: state.value.dialpad.from,
        callingEntityType: 'agent',
        callingEntityId: authStore.details.id,
        callCenterId: callCenterStore.selectedCallCenter
      }
    })

    // Call Error event
    call.on('error', error => {
      console.error('TWILIO CALL ERROR')
      console.error(error)
      state.value.isConnecting = false
    })

    // Call Warning event
    call.on('warning', (warningName, warningData) => {
      console.warn('TWILIO CALL WARNING')
      console.warn(warningName, warningData)
    })

    call.on('warning-cleared', function () {
      console.info('TWILIO CALL WARNING - CLEARED')
    })

    // For outgoing calls, the "accept" event is emitted when the Call's media session has finished setting up.
    call.on('accept', () => {
      state.value.activeCallSid = call.parameters.CallSid
      state.value.isConnecting = false

      state.value.isDialpadOpen = false

      socketStore.updateAgentStatus('on-call')
    })

    call.on('disconnect', () => {
      state.value.activeCallSid = null
      state.value.isConnecting = false

      socketStore.updateAgentStatus('available')
    })
  } catch (error) {
    console.error('Failed to initiate call:', error)
    state.value.isConnecting = false
  }
}

function hangUp() {
  call.disconnect()

  resetPhone()
}

function toggleMute() {
  call.mute(!state.value.device.isMuted)
  state.value.device.isMuted = !state.value.device.isMuted
}

function resetPhone() {
  state.value.device.isMuted = false
  state.value.dialpad.from = ''
  state.value.dialpad.to = ''
  state.value.dialpad.fromIsValid = false
  state.value.dialpad.toIsValid = false
  state.value.activeCallSid = null
  state.value.activeConferenceName = null
  state.value.isConnecting = false
}

function keypadPress(digit) {
  call?.sendDigits(digit)

  // Add digit to the state.dialpad.to
  state.value.dialpad.to += digit
}

const fromValidator = usePhoneValidator()
const toValidator = usePhoneValidator()

// Watch for changes in the dialpad.from and dialpad.to. and re-validate
watchEffect(() => {
  fromValidator.value = fromValidator.validatePhoneNumber(state.value.dialpad.from)
  toValidator.value = toValidator.validatePhoneNumber(state.value.dialpad.to)
})

// Watch for changes in the calls list
watch(
  () => socketStore.callCenterConferences,
  () => {
    // If the user is in an active call, and that call sid is in one of the calls participants array, make it the selected call
    if (call?.parameters?.CallSid) {
      const activeConference = socketStore.callCenterConferences.find(conf =>
        conf.participants?.some(participants => participants.CallSid === call?.parameters?.CallSid)
      )
      if (activeConference) {
        state.value.selectedContact = activeConference
        if (state.value.wrapUpData.agreementId) {
          linkAgreementToContact()
        } else if (pendingPreselectedAgreementId.value) {
          void preselectAgreementById(pendingPreselectedAgreementId.value)
        }
      }
    }
  },
  {
    deep: true
  }
)

async function completeWrapUp() {
  const isFormCorrect = await v$.value.$validate()
  if (!isFormCorrect) {
    return
  }

  if (!state.value.wrapUpData.agreementId) {
    unlinkedCustomerModalIsOpen.value = true
  } else {
    submitWrapUp()
  }
}

async function submitWrapUp() {
  wrapupIsLoading.value = true
  const isFormCorrect = await vUnlinked$.value.$validate()

  if (!isFormCorrect) {
    wrapupIsLoading.value = false
    return
  }

  const newObj = {
    conferenceName: state.value.selectedContact?.name || null,
    ...state.value.wrapUpData,
    answeredBy: state.value.wrapUpData.answeredBy == 'N/A' ? null : state.value.wrapUpData.answeredBy
  }

  socketStore.submitCallWrapUp(newObj)

  // reset the wrap up data & vuelidate
  state.value.wrapUpData = {
    agreementId: null,
    reasonForCall: null,
    answeredBy: null,
    tags: [],
    agentConsidersCompliant: false,
    notes: '',
    unlinkedReason: null
  }

  v$.value.$reset()

  // unselect the contact
  state.value.selectedContact = null
  wrapupIsLoading.value = false
  unlinkedCustomerModalIsOpen.value = false
}

// watch for selection change
watch(
  () => state.value.selectedContact,
  (newContact, oldContact) => {
    if (newContact?.sid == oldContact?.sid) {
      return
    }

    const agreementIdToPreserve =
      preserveAgreementSelectionOnNextContactChange.value ? state.value.wrapUpData.agreementId : null

    // if the selected contact is changed, reset the wrap up data
    state.value.wrapUpData = {
      agreementId: agreementIdToPreserve,
      reasonForCall: null,
      answeredBy: null,
      tags: [],
      agentConsidersCompliant: false,
      notes: ''
    }

    preserveAgreementSelectionOnNextContactChange.value = false

    if (newContact && pendingPreselectedAgreementId.value) {
      void preselectAgreementById(pendingPreselectedAgreementId.value)
    }
  }
)

const emitter = inject('emitter')

emitter.on('phone-set-numbers', data => {
  // *Listen* for event

  state.value.isMinimized = false
  state.value.selectedContact = null
  state.value.dialpad.to = data.to.number
  state.value.dialpad.toName = data.to.name
  state.value.dialpad.from = data.from.number
  state.value.dialpad.fromName = data.from.name
  state.value.isDialpadOpen = true

  if (data?.to?.agreementId) {
    pendingPreselectedAgreementId.value = data.to.agreementId
    void preselectAgreementById(data.to.agreementId)
  } else {
    preserveAgreementSelectionOnNextContactChange.value = false
    pendingPreselectedAgreementId.value = null
  }
})

onMounted(() => {
  // Listen for user closing the tab
  window.addEventListener('beforeunload', handleBeforeUnload)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload)

  disposeSearch()

  // Clear token refresh timer
  if (tokenRefreshTimer) {
    clearTimeout(tokenRefreshTimer)
    tokenRefreshTimer = null
  }
})

const handleBeforeUnload = event => {
  // Check for tab closing while in an active call
  if (state.value.activeCallSid) {
    event.preventDefault()
  }
}
</script>

<style>
.contact-panel__wrapper {
  position: fixed;
  bottom: 0;
  z-index: 115;
}

.contact-panel {
  background-color: var(--bg-primary_alt);
  box-shadow: 0 0 10px 0 rgb(34 41 47 / 10%);
  border: 1px solid var(--border-secondary);
  border-bottom: none;
  border-radius: var(--rounded-lg) var(--rounded-lg) 0 0;
  height: 420px;
  display: flex;
  color: var(--text-primary);
  transition:
    height 0.3s,
    width 0.3s;
}

.contact-panel__inner-wrapper {
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.contact-panel--minimized {
  height: 40px;
}

.contact-panel--unavailable {
  height: fit-content;
}

.contact-panel__section {
  display: flex;
  flex-direction: column;
  min-width: 260px;
  max-width: 400px;
  height: 100%;
  overflow: hidden;
}

.contact-panel__section-content {
  flex: 1;
  overflow-y: auto;
  padding: var(--s-2);
}

.contact-panel__section-footer {
  padding: var(--s-2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-panel__keypad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: var(--s-1);
  grid-row-gap: var(--s-1);
  margin: 20px auto;
  width: fit-content;
}

.contact-panel__keypad_button {
  background-color: var(--bg-secondary_alt);
  border-radius: 100px;
  border: 1px solid var(--border-tertiary);
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.contact-panel__keypad_button:hover {
  background: var(--bg-tertiary);
  cursor: pointer;
}

.contact-panel__customer-selector {
  display: flex;
  gap: var(--s-3);
  align-items: center;
  justify-content: space-between;
  padding: var(--s-3);
  border-radius: var(--rounded);
  cursor: pointer;
  width: 100%;
}

.contact-panel__customer-selector:hover {
  background-color: var(--bg-secondary);
}

.contact-panel__buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -15px;
  gap: var(--s-4);
}

.contact-panel__buttons__button {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-primary_alt);
  box-shadow: 0 0px 8px 2px rgb(34 41 47 / 10%);
  border-radius: var(--rounded-md);
  cursor: pointer;
  border: 1px solid var(--border-color);
}

.contact-panel__buttons__button:hover {
  background-color: var(--fg-brand);
  color: white;
}

.contact-panel--pulsing {
  animation: pulse-glow 1s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%,
  100% {
    box-shadow: 0 0 10px 0 var(--bg-brand-solid);
  }
  50% {
    box-shadow: 0 0 80px 30px var(--bg-brand-solid);
  }
}
</style>
